import { Delete } from "@mui/icons-material";
import { IconButton, Stack, SxProps, Theme, alpha } from "@mui/material";
import React from "react";
import theme from "theme";

/**
 * Component properties
 */
interface Props {
  selected: boolean;
  onDeleteClick?: () => void;
}

/**
 * Component for field drag handle
 */
const FieldDragHandle: React.FC<Props> = ({
  selected,
  children,
  onDeleteClick
}) => {
  const selectedStyle: SxProps<Theme> = {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    border: "1px solid rgba(39, 128, 98, 0.5)",
    borderRadius: 1,
    p: 1.5
  };
  
  return (
    <Stack
      position="relative"
      sx={ selected ? selectedStyle : { cursor: "pointer" } }
    >
      { children }
      { selected &&
        <IconButton
          onClick={ onDeleteClick }
          disabled={ !onDeleteClick }
          size="medium"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            backgroundColor: "#fff",
            border: "1px solid #e5c6c3",
            padding: 0.5,
            color: "#a33b33",
            borderRadius: 1,
            "&:hover": {
              backgroundColor: "#fff"
            }
          }}
        >
          <Delete/>
        </IconButton>
      }
    </Stack>
  );
};

export default FieldDragHandle;